import {Button} from "primereact/button";
import {Booking} from "../../data/Booking";
import {confirmPopup, ConfirmPopup} from "primereact/confirmpopup";
import {useState} from "react";
import BookingEditSidebar from "./BookingEditSidebar";

function BookingComponent({
                              booking,
                              onBookingChanged,
                              onBookingDeleted,
                          }: {
    booking: Booking;
    onBookingChanged(booking: Booking): void;
    onBookingDeleted(booking: Booking): void;
}) {
    const [sidebarVisible, setSidebarVisible] = useState(false);

    const openSidebar = () => {
        setSidebarVisible(true);
    };

    const saveChanges = async (updatedBooking: Booking) => {
        try {
            const response = await fetch(
                `/api/booking/entries/${updatedBooking.id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(updatedBooking),
                    credentials: "include",
                },
            );

            if (response.ok) {
                onBookingChanged(updatedBooking);
                setSidebarVisible(false);
            } else {
                console.error("Failed to update booking");
            }
        } catch (error) {
            console.error("Error updating booking:", error);
        }
    };

    const personString = booking.amount === 1 ? "Person" : "Personen";

    async function deleteBooking() {
        await fetch(
            `/api/booking/entries/${booking.id}`,
            {
                method: "DELETE",
                credentials: "include",
            },
        );

        onBookingDeleted(booking);
    }

    const accept = () => {
        deleteBooking();
    };

    const reject = () => {
    };

    const confirmDelete = (event: any) => {
        confirmPopup({
            target: event.currentTarget,
            message: `Willst du die Buchung von ${booking.name} wirklich löschen?`,
            icon: "pi pi-exclamation-triangle",
            defaultFocus: "accept",
            accept,
            reject,
        });
    };

    return (
        <div className="border-round surface-50 p-3 shadow-1 mb-3">
            <div className="flex justify-content-between align-items-center mb-2">
                <div>
                    <h3 className="m-0">{booking.amount + " " + personString}</h3>
                    <p className="m-0 text-sm text-color-secondary">{booking.name}</p>
                </div>
                <div className="flex gap-2">
                    <Button
                        icon="pi pi-pencil"
                        severity="info"
                        className="p-button-rounded p-button-text"
                        onClick={openSidebar}
                    />
                    <Button
                        icon="pi pi-trash"
                        severity="danger"
                        className="p-button-rounded p-button-text"
                        onClick={confirmDelete}
                    />
                </div>
            </div>

            <BookingEditSidebar
                visible={sidebarVisible}
                onHide={() => setSidebarVisible(false)}
                booking={booking}
                onSave={saveChanges}
            />

            <ConfirmPopup/>

            <div className="mt-2">
                {booking.email && (
                    <div className="flex flex-row flex-wrap gap-2">
                        <p className="font-bold m-0">E-Mail</p>
                        <p className="m-0">{booking.email}</p>
                    </div>
                )}
                {booking.phone && (
                    <div className="flex flex-row flex-wrap gap-2">
                        <p className="font-bold m-0">Telefon</p>
                        <p className="m-0">{booking.phone}</p>
                    </div>
                )}
                {booking.comment && (
                    <div className="flex flex-row flex-wrap gap-2">
                        <p className="font-bold m-0">Kommentar</p>
                        <p className="m-0">{booking.comment}</p>
                    </div>
                )}
            </div>

            <div className="text-xs text-secondary mt-2">{booking.id}</div>
        </div>
    );
}

export default BookingComponent;
